'use strict'
import { request } from '../../plugins/http'

export default async ({userId}) => {
    return await request.get('/controleProdutividade', {params: {userId: userId}})
}